import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { DocubirdCache, OneNoteProgId, SharePointFolderContentTypeIds, validSigningRequestExtensions } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { CacheHelper } from "../../../utilities/CacheHelper";
import { getValidHooks } from "../../../src/taskpane/services/HooksService";
import { HookType } from "../../../src/taskpane/components/_v2/redux/api/local/api-local-interfaces";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { DocumentSignature20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/DocumentSignature20Regular";

export function useMenuItem_SigningRequest(selectedItems: any[], waitFor: boolean, setApprovalFiles: (approvalFiles: any[]) => void, setIsSigningPanelOpen: (isSigningPanelOpen: boolean) => void) {
    const languageStrings = React.useContext(LanguageContext);

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

    const onSigningRequestClick = React.useCallback(() => {
        setApprovalFiles(selectedItems);
        setIsSigningPanelOpen(true);
    }, [selectedItems, setApprovalFiles, setIsSigningPanelOpen]);

    const menuItem_SigningRequest = React.useMemo(() => {
        const hasSelection = selectedItems?.length > 0;

        if (!hasSelection || CacheHelper.get(DocubirdCache.signingEnabled) !== true || !currentDirectory?.siteDisplayName || !currentDirectory?.DocumentLibrary) {
            return null;
        }

        const validHooks = getValidHooks(CacheHelper.get(DocubirdCache.hooks)?.filter(h => h.typeId === HookType.Sign), currentDirectory);
        const signingFlowsAvailable = validHooks?.length > 0;
        if (!signingFlowsAvailable) {
            return null;
        }

        const hasFolderOrOneNoteFolder = selectedItems.some(x =>
            x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) || x.ProgId === OneNoteProgId
        );

        const areAllExtensionsValid = selectedItems.every(x => {
            const extension = x.File_x0020_Type?.toUpperCase();
            return validSigningRequestExtensions.includes(extension);
        });

        const shouldShowMenuItem = !hasFolderOrOneNoteFolder && areAllExtensionsValid;

        if (shouldShowMenuItem) {
            return {
                key: "signinRequest",
                disabled: waitFor === true,
                text: languageStrings.SigningRequest,
                // iconProps: { iconName: "InsertSignatureLine" },
                iconProps: {},
                onRenderIcon: () => <DocumentSignature20Regular className={menuItemIconStyles} />,
                onClick: onSigningRequestClick
            } as IContextualMenuItem;
        }

        return null;
    }, [selectedItems, waitFor, currentDirectory, onSigningRequestClick])

    return {
        menuItem_SigningRequest
    }
}